import React from 'react';
import { GlobalConfiguration } from '../../../models/GlobalConfiguration';
import StyledFieldDescription from '../../styles/StyledFieldDescription';
import { StyledInput } from '../../styles/StyledInputs';
import StyledSection from '../../styles/StyledSection';
import { StyledFieldRow, StyledHeading, StyledLabel } from '../../styles/styles';
import ConfigFieldLabel from './ConfigFieldLabel';
import { GLOBAL_CONFIG_FIELD_LABELS, INVESTMENT_CONFIG_FIELDS } from './globalConfigFieldConfig';

type InvestmentConfigSectionProps = {
  config: GlobalConfiguration;
  dirtyFields: Set<string>;
  onChange: (field: string, value: unknown) => void;
};

export default function InvestmentConfigSection({
  config,
  dirtyFields,
  onChange,
}: InvestmentConfigSectionProps) {
  return (
    <StyledSection tone="tone1">
      <StyledHeading tone="tone1" headerVariant="heading2">
        Investment Configuration
      </StyledHeading>
      {INVESTMENT_CONFIG_FIELDS.map((fieldKey) => (
        <StyledFieldRow stacked sx={{ mb: 2 }} key={fieldKey}>
          <StyledLabel stacked>
            <ConfigFieldLabel
              fieldKey={fieldKey}
              label={GLOBAL_CONFIG_FIELD_LABELS[fieldKey]}
              dirtyFields={dirtyFields}
            />
          </StyledLabel>
          <StyledFieldDescription stacked>
            {GLOBAL_CONFIG_FIELD_LABELS[fieldKey]} value.
          </StyledFieldDescription>
          <StyledInput
            type="number"
            value={(config as unknown as Record<string, unknown>)[fieldKey] || ''}
            onChange={(e) => onChange(fieldKey, parseInt(e.target.value) || 0)}
            inputProps={{ min: 0, step: 1000 }}
          />
        </StyledFieldRow>
      ))}
    </StyledSection>
  );
}
